/**
 * Point d'entrée du frontend NORYVOX.
 * Monte React 18 avec le thème MUI (clair/sombre/système), React Query et le routeur.
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ThemeModeProvider } from './ThemeModeProvider';
import App from './App';
import { queryClient } from './queryClient';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Élément racine #root introuvable dans index.html.');
}

createRoot(container).render(
  <StrictMode>
    <ThemeModeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeModeProvider>
  </StrictMode>,
);
